import { render } from "./ButtonModalConfiguration.vue?vue&type=template&id=35106970&scoped=true"
import script from "./ButtonModalConfiguration.vue?vue&type=script&lang=js"
export * from "./ButtonModalConfiguration.vue?vue&type=script&lang=js"

import "./ButtonModalConfiguration.vue?vue&type=style&index=0&id=35106970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35106970"],['__file',"src/components/survey/ButtonModalConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35106970"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35106970', __exports__)) {
    api.reload('35106970', __exports__)
  }
  
  module.hot.accept("./ButtonModalConfiguration.vue?vue&type=template&id=35106970&scoped=true", () => {
    api.rerender('35106970', render)
  })

}


export default __exports__